import { rem } from 'polished'
import { useMemo } from 'react'
import styled from 'styled-components'
import { ChatMap } from 'tripPlanner/components/ChatMap'
import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import { useMapInteractionStyle } from '../../contexts/MapInteractionContext'
import type { OfferDetailGeoLocation } from './types'

const MapWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16 / 10;
  min-height: ${rem(260)};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;
`

interface Props {
  geoLocation: OfferDetailGeoLocation
  offerName: string
  onEnlarge?: () => void
}

function OfferDetailMap({ geoLocation, offerName, onEnlarge }: Props) {
  const placeId = `offer-${geoLocation.lat}-${geoLocation.lng}`
  const { mapStyleMode, onMapStyleModeChange } = useMapInteractionStyle()

  const markers = useMemo<Array<ChatMapMarker>>(() => [{
    placeId,
    lat: geoLocation.lat,
    lng: geoLocation.lng,
    label: offerName,
  }], [placeId, geoLocation.lat, geoLocation.lng, offerName])

  return (
    <MapWrapper>
      <ChatMap
        markers={markers}
        initialCenterPlaceId={placeId}
        scrollZoom={false}
        showPitchToggle={false}
        showAttributionControl={false}
        mapStyleMode={mapStyleMode}
        onMapStyleModeChange={onMapStyleModeChange}
        onEnlarge={onEnlarge}
      />
    </MapWrapper>
  )
}

export default OfferDetailMap
